import React from 'react';
import PropTypes from 'prop-types';

import { publicationTypes } from '../../publications/PublicationsParser';
import { fetchPublications } from '../../helpers/DataProvider';

import './PublicationsSection.css';

class PublicationsSection extends React.Component {
  constructor() {
    super();

    this.state = {
      publications: {},
    };
  }

  componentDidMount() {
    const { projectid } = this.props;

    fetchPublications((publications) => {
      const wantedPublication = publication => publication.projectid === `${projectid}`;
      const projectPublications = publications.filter(wantedPublication);

      this.setState({
        publications: projectPublications,
      });
    });
  }

  render() {
    const { publications } = this.state;

    if (Object.keys(publications).length === 0) {
      return null;
    }
    return (
      <div id="PublicationsSection">
        <h1> PUBLICATIONS & LINKS</h1>
        {
          publications.map(publication => (
            <div className="publication" key={publication.title}>
              <div className="vertical">{publication.year}</div>
              <a href={publication.link} target="_blank" rel="noopener noreferrer">
                <div className="text">
                  <h3>{publicationTypes[publication.type]}</h3>
                  <p>{publication.title}</p>
                </div>
              </a>
            </div>
          ))
        }
      </div>
    );
  }
}

PublicationsSection.propTypes = {
  projectid: PropTypes.string.isRequired,
};

export default PublicationsSection;
